import { render } from "./DescriptionBlock.vue?vue&type=template&id=7b70319e&scoped=true&ts=true"
import script from "./DescriptionBlock.vue?vue&type=script&lang=ts"
export * from "./DescriptionBlock.vue?vue&type=script&lang=ts"

import "./DescriptionBlock.vue?vue&type=style&index=0&id=7b70319e&scoped=true&lang=scss"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b70319e"]])

export default __exports__